// A browser step that may never answer (a hidden print frame that never loads) is given up on with
// a message, so the screen waiting for it is never stuck.

/** The work, or a rejection with message once ms passed without it settling. */
export function withTimeout<T>(work: Promise<T>, ms: number, message: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const late = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new Error(message)), ms);
  });
  return Promise.race([work, late]).finally(() => clearTimeout(timer));
}
